import {FC, useEffect, useRef, useState} from 'react'
import {useParams} from "react-router-dom";
import {getAllPagesOperation} from "../wordpress/Operations";
import Nav from "../components/Nav";
import Main from "../components/main/Main";
import Sidebar from "../components/Sidebar";
import { bookingFlows, bookingDefault, settings } from '../constants/global'
import Footer from "../components/Footer";
import staticPageContent from "../lib/static-page-content";
import Modal from "../components/common/Modal/Modal";
import Logo from "../components/Hjulskifte/Arval/Logo";
import {trackBookingStep} from "../lib/gtm";
interface Props {
    className?: string
}
const Container: FC<Props> = ({ className }) => {

    const [content, setData] = useState(null);
    const [height, setHeight] = useState(0);
    const [booking, setBooking] = useState(bookingDefault);
    const bookingFlow = bookingFlows[booking.booking_flow]

    useEffect(() => {
        if (!content) {
            getAllPagesOperation(setData)
        }
    }, [content]);

    const trackedStep = useRef<string>(null);
    useEffect(() => {
        if (content && bookingFlow.step && bookingFlow.step !== trackedStep.current) {
            trackedStep.current = bookingFlow.step;
            trackBookingStep(booking);
        }
    }, [bookingFlow.step, content]);

    let { slug, id } = useParams();
    if(id) {
        booking.order_key = id
    }
    if(!content) // Wait for static content to load from Wordpress
        return

    let pageContent:ContentPage = staticPageContent(slug, content)
    bookingFlows[booking.booking_flow].step = pageContent.content_type
    settings.auth = content.auth
    settings.vbo = content.vbo
    settings.rental = content.rental
    settings.debug = content.settings.debug
    settings.tire_shop = content.settings.tire_shop
    settings.react_thank_you = content.settings.react_thank_you
    settings.url = content.path

    if(process.env.NODE_ENV === 'development')
        booking.debug = false

    if(settings.debug) {
        booking.debug = true
    }else{
        console.log = function() {} // Prevent all console logs
    }

    if(className)
        booking.classNames.push(className);

    if(booking.classNames)
        className = booking.classNames.join(' ')

    let carBrand = booking.car.brand ? booking.car.brand.toLowerCase() : ''

    let divElement = document.querySelector("#h-container");

    if(bookingFlow.step === 'date' && divElement && divElement.clientHeight !== height)
        setHeight(divElement.clientHeight);

    if(bookingFlow.step != 'date' && divElement && 0 !== height)
        setHeight(0);

    console.log(settings)
    return (
        <div id={'h-container'} className={className} style={{ minHeight: height }}>
            {bookingFlow.step === 'complete' ? (
                <>
                    <Main content={content} booking={booking} setBooking={setBooking}/>
                </>
            ):(
                <>
                    <Nav content={content} booking={booking} setBooking={setBooking}/>
                    <Logo booking={booking}/>
                    <section id="wco-single-booking-page" className={'o-conten-wrap page-booking ' + bookingFlow.step + ' flow-' + booking.booking_flow + ' brand-'+carBrand}>
                        <div className="container">
                            <Modal booking={booking} setBooking={setBooking}/>
                            <div className="row">

                                    <>
                                        <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 col-xxs-12">
                                            <Main content={content} booking={booking} setBooking={setBooking}/>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12 col-xxs-12 booking-sidebar-container">
                                            <Sidebar booking={booking} workshops={content.workshops} setBooking={setBooking} content={content}/>
                                        </div>
                                    </>

                            </div>
                        </div>
                    </section>
                    <Footer booking={booking} setBooking={setBooking} content={content}/>
                </> )}
        </div>
    );
};

export default Container
